import { Button } from '@xprog/prensa'
import { ButtonProps } from '@xprog/prensa/types'
import React from 'react'

export interface GhostButtonProps extends ButtonProps { isUppercase?: boolean; }

const GhostButton: React.FC<GhostButtonProps> = ({ children, isUppercase, ...otherProps }) => {

  const styles = {
    button: {
      height: '20px',
      padding: '0px'
    },
    label: {
      color: '$basicBlack',
      fontFamily: '$primary',
      fontSize: '$caption3',
      fontWeight: '$caption3',
      lineHeight: '$caption3',
      textTransform: isUppercase ? 'uppercase' : 'none'
    }
  }

  return (
    <Button
      variant='ghost'
      css={styles}
      {...otherProps}
    >
      {children}
    </Button>
  )
}

export default GhostButton